import { css } from 'styled-components';
import token from 'styled-token';

/** @class PaginationListMixin */
/** @method */
export var PaginationListMixin = function PaginationListMixin(props) {
  return token({
    margin: 'PaginationList.margin',
    padding: 'PaginationList.padding',
    alignItems: 'PaginationList.alignItems'
  }, function (_ref) {
    var _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0 : _ref$padding,
      _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? 'center' : _ref$alignItems;
    return css(["margin:", ";padding:", ";list-style-type:none;display:flex;flex-flow:row;align-items:", ";"], margin, padding, alignItems);
  })(props);
};